import { getEnvironment } from "../utils/environment";

const CLAIM_NAMESPACE = `https://flights-partner-strategy-manager.${getEnvironment().env === "PROD" ? "prod" : "dqs"}.booking.com`;

export const ROLE_CLAIM = `${CLAIM_NAMESPACE}/role`;
export const AIRLINE_CODE_CLAIM = `${CLAIM_NAMESPACE}/airlineCode`;
export const LAST_LOGIN = `${CLAIM_NAMESPACE}/lastLogin`;
